import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  isInquiryProcessAlias,
  isNegotiationProcessAlias,
  OFFER,
} from '../../transactions/transaction';

import { Heading, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';

export const CONTACT_USER_LINK = 'inquiryModalContactUserLink';

/**
 * Whether the author can be contacted from the listing page (not in the inquiry process, nor
 * in a negotiation over an offer, where the order panel already does it).
 *
 * @param {Object} listing
 * @returns {boolean}
 */
export const canContactAuthor = listing => {
  const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
  const unitType = listing?.attributes?.publicData?.unitType || '';
  const isInquiryProcess = isInquiryProcessAlias(transactionProcessAlias);
  const isNegotiationProcess = isNegotiationProcessAlias(transactionProcessAlias);
  return !(isInquiryProcess || (isNegotiationProcess && unitType === OFFER));
};

const SectionAuthorMaybe = props => {
  const {
    name,
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
    showCard = true,
  } = props;

  if (!listing.author) {
    return null;
  }

  const showContact = canContactAuthor(listing);

  return (
    <section id="author" className={showCard ? css.sectionAuthor : css.sectionAuthorModalOnly}>
      {showCard ? (
        <>
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            {name ? (
              <FormattedMessage
                id="ListingPage.profile.meetTitle"
                values={{ name: name.trim().split(/\s+/)[0] }}
              />
            ) : (
              <FormattedMessage id="ListingPage.aboutProviderTitle" />
            )}
          </Heading>
          <UserCard
            user={listing.author}
            currentUser={currentUser}
            onContactUser={onContactUser}
            showContact={showContact}
            contactLinkId={CONTACT_USER_LINK}
          />
        </>
      ) : null}
      <Modal
        id="ListingPage.inquiry"
        contentClassName={css.inquiryModalContent}
        isOpen={isInquiryModalOpen}
        onClose={onCloseInquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        focusElementId={CONTACT_USER_LINK}
      >
        <InquiryForm
          className={css.inquiryForm}
          submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendInquiryError={sendInquiryError}
          onSubmit={onSubmitInquiry}
          inProgress={sendInquiryInProgress}
        />
      </Modal>
    </section>
  );
};

export default SectionAuthorMaybe;
